import { onBlockingDialogOpen } from 'owa-mail-compose-actions/lib/actions/messageValidationFailed';
import { orchestrator } from 'satcheljs';
import { composeValidationFailedForMessageWithSharingIssueTimeDialogOpen } from '../actions/internalActions';
const SHARING_ISSUE_ERROR_CODE = 'SharingIssue';

orchestrator(onBlockingDialogOpen, ({ composeId, errorCode, dialogOpenTime }) => {
    switch (errorCode) {
        case SHARING_ISSUE_ERROR_CODE:
            composeValidationFailedForMessageWithSharingIssueTimeDialogOpen(
                composeId,
                dialogOpenTime
            );
            break;
    }
});
